/* eslint-disable i18n/no-russian-character */
'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect, useState } from 'react';

import { GTMErrorPage } from '@/fo/api/gtm';

const isDev = process.env.NODE_ENV !== 'production';
const MAX_RETRY_COUNT = 3;
const RETRY_DELAY = 300;
const RETRY_PARAM = 'retry_count' as const;

interface GlobalErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

const getRetryUrl = (retryCount: number): URL => {
  const url = new URL(window.location.href);
  url.searchParams.set(RETRY_PARAM, (retryCount + 1).toString());

  if (retryCount >= MAX_RETRY_COUNT) {
    url.pathname = '/';
  }

  return url;
};

const getCleanUrl = (): URL => {
  const url = new URL(window.location.href);
  url.searchParams.delete(RETRY_PARAM);
  return url;
};

export default function GlobalError({ error }: GlobalErrorProps) {
  const [showError, setShowError] = useState(isDev);

  useEffect(() => {
    Sentry.captureException(error);
    // eslint-disable-next-line
    console.error(error);

    if (isDev) return;

    const url = new URL(window.location.href);
    const retryCount = Number(url.searchParams.get(RETRY_PARAM) || '0');
    const isHomePage = url.pathname === '/' || url.pathname === '';
    const isLimit = retryCount >= MAX_RETRY_COUNT;

    if (isLimit && isHomePage) {
      setShowError(true);
      return;
    }

    const t = setTimeout(() => {
      window.location.href = getRetryUrl(retryCount).toString();
    }, RETRY_DELAY);

    return () => clearTimeout(t);
  }, [error]);

  const onReset = () => {
    window.location.href = getCleanUrl().toString();
  };

  if (!showError) {
    return (
      <html>
        <body style={{ display: 'none' }}>
          <div />
        </body>
      </html>
    );
  }

  return (
    <html>
      <body>
        <h1>Ошибка сервера</h1>
        <p>
          <button onClick={onReset}>Обновить страницу</button>
        </p>
        <GTMErrorPage />
      </body>
    </html>
  );
}
